import { PageRoute } from '../constants/page-route.const';
import { solutionVariantMap } from '../pages/solutions/solutions-types';

const STATIC_PATHS = new Set(['/', '/about', '/become-a-partner', '/perks', '/solutions']);

const TERMS_PATHS = new Set<string>([
  PageRoute.CONFIDENTIALITY,
  PageRoute.COOKIE,
  PageRoute.DPA,
  PageRoute.PRIVACY,
  PageRoute.TERMS,
  PageRoute.TERMS_BASE,
]);

export const isKnownMarketingPath = (pathname: string): boolean => {
  const normalized =
    pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

  if (STATIC_PATHS.has(normalized)) {
    return true;
  }

  if (TERMS_PATHS.has(normalized)) {
    return true;
  }

  if (normalized.startsWith('/solutions/')) {
    const slug = normalized.slice('/solutions/'.length);
    return (solutionVariantMap as readonly string[]).includes(slug);
  }

  return false;
};
